var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-container"},[(_vm.cartLoading)?_c('Loader',{staticClass:"my-5"}):[(_vm.$store.getters.cartItems.length)?_c('ShoppingCart'):_c('EmptyCart')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }